/**
 * Single source of truth for the free sample exam size and time limit.
 *
 * Every label that mentions the question count or the time limit must read
 * from here, so it can be changed in one spot.
 */
export const TRIAL_QUESTION_COUNT = 10;
export const TRIAL_DURATION_MINUTES = 15;
export const TRIAL_DURATION_SECONDS = TRIAL_DURATION_MINUTES * 60;

export const TRIAL_EXAM_LABEL = `Try ${TRIAL_QUESTION_COUNT} sample questions`;
export const TRIAL_EXAM_TITLE = `Try ${TRIAL_QUESTION_COUNT} CTFL 4.0.1 sample questions`;
export const TRIAL_QUESTIONS_LINE = `${TRIAL_QUESTION_COUNT} questions`;
export const TRIAL_TIME_LINE = `${TRIAL_DURATION_MINUTES} minutes`;
export const TRIAL_SCORING_LINE =
  "Scored at the end, with an explanation for almost every answer option.";
export const TRIAL_DISCLAIMER_LINE = "Nothing is saved to your progress.";
